
import { Vue, Component } from "vue-property-decorator";
import { formatDateWithTime } from "../../../utils";
import { getModule } from "vuex-module-decorators";
import BarcodeSystemModule from "@/store/modules/barcodeSystem";
import ManifestModule from "@/store/modules/barcodeSystem/manifest";
import { ManifestResource } from "@/models/api/barcodeSystem/manifests/get";

const manifestModuleState = getModule(ManifestModule);

@Component
export default class ManifestHeader extends Vue {
  showRestoreManifestPrompt: boolean = false;
  showHideManifestPrompt: boolean = false;

  get currentManifest(): ManifestResource {
    return manifestModuleState.currentManifest;
  }

  get isNew(): boolean {
    return manifestModuleState.currentManifest.id ? false : true;
  }

  get manifestName(): string {
    return manifestModuleState.currentManifest.manifestName;
  }

  set manifestName(val: string) {
    manifestModuleState.updateCurrentManifestName(val);
  }

  get deliveryDate(): string {
    return manifestModuleState.currentManifest.deliveryDate;
  }

  set deliveryDate(val: string) {
    manifestModuleState.updateCurrentManifestDeliveryDate(val);
  }

  get tripDays(): number {
    return this.currentManifest.tripDays;
  }

  set tripDays(val: number) {
    manifestModuleState.updateCurrentManifestTripDays(val);
  }

  get isWillCallManifest(): boolean {
    return this.currentManifest.isWillCallManifest;
  }

  set isWillCallManifest(val: boolean) {
    manifestModuleState.updateCurrentManifestIsWillCallManifest(val);
  }

  get facilityCode(): string {
    return this.currentManifest.facilityCode; 
  }

  set facilityCode(val: string){
  }

  get createdDateTimeFormatted(): string {
    return formatDateWithTime(this.currentManifest.createdDate);
  }

  set createdDateTimeFormatted(val: string){
  }  
  
  get updatedDateTimeFormatted(): string {
    return formatDateWithTime(this.currentManifest.lastUpdatedDate);
  }

  set updatedDateTimeFormatted(val: string){
  }

  get lastUpdatedBy(): string {
    return this.currentManifest.lastUpdatedBy; 
  }

  set lastUpdatedBy(val: string){
  }

  promptForRestoreManifest()
  {
    this.showRestoreManifestPrompt=true;
  }

  promptForHideManifest()
  {
    this.showHideManifestPrompt=true;
  }

  closePrompt()
  {
    this.showRestoreManifestPrompt=false;
    this.showHideManifestPrompt=false;
  }

  restoreManifest() {
    this.closePrompt();
    this.$emit("restoreManifest");
  }

  hideManifest() {
    this.closePrompt();
    this.$emit("hideManifest");
  }
  
}
